<template>
  <div class="relative py-24 sm:py-32 min-h-fit">
    <UiContainer>
      <div class="mx-auto max-w-2xl lg:max-w-none">
        <UiTitle
          size="5xl"
          type="h2"
          align="center"
          :code="t('home.worldMetrics.tag')"
        >
          {{ t('home.worldMetrics.title') }}
        </UiTitle>
        <UiParagraph
          class="mt-6"
          align="center"
          size="lg"
        >
          {{ t('home.worldMetrics.description') }}
        </UiParagraph>

        <dl
          class="mt-16 grid grid-cols-1 gap-0.5 overflow-hidden rounded-2xl
        text-center sm:grid-cols-2 lg:grid-cols-4"
        >
          <div
            v-for="stat in stats"
            :key="stat.id"
            class="flex flex-col bg-gray-400/5 p-8"
          >
            <dt class="text-sm/6 font-semibold">
              {{ stat.name }}
            </dt>
            <dd
              class="order-first text-3xl font-semibold tracking-tight"
            >
              {{ stat.value }}
            </dd>
          </div>
        </dl>
      </div>
    </UiContainer>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import UiContainer from '@/components/ui/UiContainer.vue';
import UiTitle from '@/components/ui/UiTitle.vue';
import UiParagraph from '@/components/ui/UiParagraph.vue';

const { t } = useI18n();

// Computed
const stats = computed(() => [
  { id: 1, name: t('home.worldMetrics.activeGamersWorldwide'), value: '3.32B+' },
  { id: 2, name: t('home.worldMetrics.monthlyPSNUsers'), value: '123M' },
  { id: 3, name: t('home.worldMetrics.monthlyXboxUsers'), value: '120M' },
  { id: 4, name: t('home.worldMetrics.monthlySteamUsers'), value: '132M' },
]);
</script>
